export default __webpack_public_path__ + "assets/img/ict-upload-image.1116da3d1b8d1b1c75e4cace4ba4ed1a.svg";